
import eventBus from "./eventBus.js"

export default {
  name: "WareViewFilterTag",
  components: {},
  props: {},
  data() {
    return {
      list: []
    }
  },

  computed: {},
  watch: {},
  created() {
    eventBus.$on("check-filter", val => {
      this.list = val
    })
  },
  mounted() {},
  beforeDestroy() {
    eventBus.$off("check-filter")
  },

  methods: {
    handleClearItem(val) {
      eventBus.$emit("clear-filter", val)
    },
    handleClear() {
      eventBus.$emit("clear-all")
    }
  }
}
